<script setup lang="ts">
import './grid-layout.css';
import '@sg-core/src/View/Components/Atoms/Grid/grid.css';

defineProps({
  use: {
    type: String,
    default: 'div',
  },

  gridSpacing: {
    type: [Number, String],
    default: 3,
  },

  centerSpacing: {
    type: [Number, String],
    default: 3,
  },

  sizing: {
    type: String,
    default: '3xl',
  },

  hasCenterClasses: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <component
    :is="use"
    :class="[
      'phxsg-grid__items phxsg-grid-layout',
      {
        center: hasCenterClasses,
        [`phxsg-grid--spacing-${gridSpacing}`]: gridSpacing,
        [`center--spacing-${centerSpacing}`]: centerSpacing && hasCenterClasses,
        [`center--sizing-${sizing}`]: sizing && hasCenterClasses,
      },
    ]"
  >
    <slot />
  </component>
</template>
